import {useQuery} from "@tanstack/react-query";
import {getCustomerOfferQueryOptions} from "./get-customer-offer.query-options";

export function useGetCustomerOffer(id: string) {
  return useQuery(getCustomerOfferQueryOptions(id));
}
